import * as ROUTES from './routes-plcp'

export const navRoutes = [
  {
    component: 'Home',
    exact: false,
    href: ROUTES.HOME,
    navName: 'Home',
    renderInNav: true
  },
  {
    component: 'PLPrimaryStars',
    exact: false,
    href: ROUTES.PLPRIMARYSTARS,
    navName: 'PL Primary Stars',
    renderInNav: true
  },
  {
    component: 'PLKicks',
    exact: false,
    href: ROUTES.PLKICKS,
    navName: 'PL Kicks',
    renderInNav: true
  },
  {
    component: 'PLInspires',
    exact: false,
    href: ROUTES.PLINSPIRES,
    navName: 'PL Inspires',
    renderInNav: true
  },
  {
    component: 'PLPfa',
    exact: false,
    href: ROUTES.PLPFA,
    navName: 'PL PFA',
    renderInNav: true
  },
  {
    component: 'Funding',
    exact: false,
    href: ROUTES.FUNDING,
    navName: 'Funding',
    renderInNav: true
  },
  {
    component: 'Facilities',
    exact: false,
    href: ROUTES.FACILITIES,
    navName: 'Facilities',
    renderInNav: true
  },
  {
    component: 'EconomicImpact',
    exact: false,
    href: ROUTES.ECONOMIC_IMPACT,
    navName: 'Economic Impact',
    renderInNav: true
  }
  // ,
  // {
  //   component: 'AboutThePL',
  //   exact: false,
  //   href: ROUTES.ABOUTTHEPL,
  //   navName: 'About the PL',
  //   renderInNav: true
  // }
]

export const mpNavRoutes = [
  {
    component: 'Home',
    exact: false,
    href: ROUTES.HOME_MP,
    navName: 'Home',
    renderInNav: true
  },
  {
    component: 'PLPrimaryStars',
    exact: false,
    href: ROUTES.PLPRIMARYSTARS_MP,
    navName: 'PL Primary Stars',
    renderInNav: true
  },
  {
    component: 'PLKicks',
    exact: false,
    href: ROUTES.PLKICKS_MP,
    navName: 'PL Kicks',
    renderInNav: true
  },
  {
    component: 'PLInspires',
    exact: false,
    href: ROUTES.PLINSPIRES_MP,
    navName: 'PL Inspires',
    renderInNav: true
  },
  {
    component: 'PLPfa',
    exact: false,
    href: ROUTES.PLPFA_MP,
    navName: 'PL PFA',
    renderInNav: true
  },
  {
    component: 'Funding',
    exact: false,
    href: ROUTES.FUNDING_MP,
    navName: 'Funding',
    renderInNav: true
  },
  {
    component: 'Facilities',
    exact: false,
    href: ROUTES.FACILITIES_MP,
    navName: 'Facilities',
    renderInNav: true
  },
  {
    component: 'EconomicImpact',
    exact: false,
    href: ROUTES.ECONOMIC_IMPACT_MP,
    navName: 'Economic Impact',
    renderInNav: true
  }
  // ,
  // {
  //   component: 'AboutThePL',
  //   exact: false,
  //   href: ROUTES.ABOUTTHEPL,
  //   navName: 'About the PL',
  //   renderInNav: true
  // }
]
